export default {
  isAuthLoading: state => state.isAuthLoading,
  isLoggedIn: state => state.isLoggedIn,
  idToken: state => state.idToken,
  userSub: state => state.userSub
}
